export default __webpack_public_path__ + "static/media/photo3.64177984.jpg";